function getStylesRef(refName) {
  return "___ref-".concat(refName || "");
}

export { getStylesRef };